$(document).ready(() => {
  const searchBar = $('#search-bar')
  const searchBarInput = $('#search-bar-input')
  const searchBarMenu = $('#search-bar-menu')
  const searchBarSubmit = $('#search-bar-submit')

  let url
  let key

  if (window.location.host === 'bloom.co') {
    url = 'https://blog.bloom.co/blog'
    key = 'ae8142337bbe0881b87a5e2322'
  } else {
    url = 'http://localhost:2368'
    key = 'e1892d3516e56cfe436d7ef84c'
  }

  new GhostSearch({
    key,
    url,
    version: 'v3',
    input: '#search-bar-input',
    results: '#search-bar-results',
    template: result => {
      const date = new Date(result.published_at)
      const formattedDate = new Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric', year: 'numeric'}).format(
        date
      )

      return `
        <a tabIndex="0" id='gh-{{ref}}' class='gh-search-item search-bar__menu__item' href='${result.url}'>
          <h2 class='search-bar__menu__item__title'>${result.title}</h2>
          <time class='search-bar__menu__item__pub-date' datetime='${date.toISOString()}'>${formattedDate}</time>
        </a>`
    },
    api: {
      resource: 'posts',
      parameters: {
        limit: 'all',
        fields: ['title', 'slug', 'published_at', 'url'],
        filter: '',
        include: '',
        order: '',
        formats: '',
      },
    },
    on: {
      afterDisplay: results => {
        if (results.length > 0) {
          searchBarMenu.show()
        } else {
          searchBarMenu.hide()
        }
      },
    },
  })

  searchBarInput.focus(() => {
    if (searchBarInput.prop('value')) {
      searchBarMenu.show()
    }
  })

  const isOrContains = (parent, node) => {
    if ($.contains(parent, node)) return true
    if (parent === node) return true

    return false
  }

  searchBarInput.on('blur', e => {
    if (!isOrContains(searchBar.get(0), e.relatedTarget)) {
      searchBarMenu.hide()
    }
  })

  const attr = 'focus-within'
  let lastElements = []

  const onFocusChange = () => {
    let lastElement

    while ((lastElement = lastElements.pop())) {
      lastElement.removeAttribute(attr)
    }

    let activeElement = document.activeElement

    // only add focus if it has not been added and is not the document element
    if (!/^(#document|HTML|BODY)$/.test(Object(activeElement).nodeName)) {
      while (activeElement && activeElement.nodeType === 1 && isOrContains(searchBar.get(0), activeElement)) {
        activeElement.setAttribute(attr, '')

        lastElements.push(activeElement)

        activeElement = activeElement.parentNode
      }
    }
  }

  searchBar.click(e => {
    const searchBarSubmitElem = searchBarSubmit.get(0)
    const target = e.target
    if (!isOrContains(searchBarSubmitElem, target)) {
      searchBarInput.focus()
    }
  })

  searchBar.get(0).addEventListener('focus', onFocusChange, true)
  searchBar.get(0).addEventListener('blur', onFocusChange, true)
})
